
import React, { useState, useEffect } from "react";
import MultiSelector from "./MultiSelector";

function DestinationSelector({passData,origin,TransportMeansSelection}) {
    
    const [DestinationSelectorOptions, setDestinationSelectorOptions] = useState([])

    let url = "";

    //TODO NO [0] PROBABLY
    switch (TransportMeansSelection[0]) {
        case 'Οδικές':
          url = '/api/roadtransport/zones_destinations/' + origin[0]
          break;
        case 'Αεροπορικές':
          url = '/api/airtransport/destinations/' + origin[0]
          break;
        case 'Θαλάσσιες':
          url = "/api/marinetransport/destinations/" + origin[0]
          break;
        case 'Σιδηροδρομικές':
          url = "/api/railtransport/destinations/" + origin[0];
        break;
        default:
          console.log('I do not recognize this fruit.');
      }
    
    useEffect(() => {
      
        //TODO NA GINEI GIA OLA OXI ME [0]
        // var url = "/api/airtransport/destinations/" + origin
    
      
        fetch(url).then((res) =>
           res.json().then((res) => {
            let DestinationValues = res.data.Destinations
            
            const DestinationSelectorOptions = []
            for (let i = 0; i < DestinationValues.length; i++) {
                DestinationSelectorOptions.push({key: DestinationValues[i]})
            }


            let DestinationSelectorProps = {
                title: "0.4 Προορισμός",
                options: DestinationSelectorOptions
            }
            
            setDestinationSelectorOptions(DestinationSelectorProps)

          })
        )
        .catch((error) => {
          console.log("Refetching data for Origins!")
        });
      }, [url]);



    return (
        // TODO isws props.passData
        <MultiSelector passData = {passData} props = {DestinationSelectorOptions} selectionsLimit = {-1}/>
    
    );
}

export default DestinationSelector;
